import type { CustomPricingContext } from "@classes-service-types/index.ts";
import { format, parseISO } from "date-fns";
import { formattedPriceFromCents as formatCents } from "@/util/formatter";
import type { FailedRow } from "./types";

/**
 * Formats a price stored in cents to a human-readable dollar string, or an em-dash when absent.
 * e.g. 150000 → "$1,500.00", undefined → "—"
 */
export const formattedPriceFromCents = (cents: number | undefined): string =>
  cents == null ? "—" : formatCents(cents);

/**
 * Converts a price stored in cents to a dollar amount for editable form inputs,
 * preserving `undefined` so an empty field stays empty rather than showing 0.
 * e.g. 150000 → 1500, undefined → undefined
 */
export const centsToDollars = (cents: number | null | undefined): number | undefined =>
  cents != null ? cents / 100 : undefined;

export const formatDate = (dateStr: string | undefined): string =>
  dateStr ? format(parseISO(dateStr), "M/d/yyyy") : "";

/** Name a failed override the way the operator sees it in the table; the id is the last resort. */
export const describeFailure = (
  rowsById: Map<string, CustomPricingContext>,
  overrideId: string,
  details: string,
): FailedRow => {
  const row = rowsById.get(overrideId);
  return {
    overrideId,
    sessionName: row?.session_name ?? overrideId,
    sessionId: row?.session_id ?? "",
    institutionName: row?.home_institution_name ?? "",
    institutionId: row?.home_institution_id ?? "",
    details,
  };
};
